import Typography from "@carrier-io/air-react/Typography";
import cn from "classnames";
import Box from "@carrier-io/air-react/Box";
import React from "react";

import styles from "./PasswordRequirements.module.scss";

export type PasswordRequirementsErrorsType = {
  errors: {
    minLength?: boolean;
    atLeastOneUppercaseLetter?: boolean;
    atLeastOneLowercaseLetter?: boolean;
    atLeastOneNumber?: boolean;
    atLeastOneSpecialCharacter?: boolean;
  };
};

export const PasswordRequirements = ({
  errors: {
    minLength = false,
    atLeastOneUppercaseLetter = false,
    atLeastOneLowercaseLetter = false,
    atLeastOneNumber = false,
    atLeastOneSpecialCharacter = false,
  },
}: PasswordRequirementsErrorsType) => {
  const getTextErrorClass = (isError: boolean) => {
    return {
      [styles.textLine__error]: isError,
    };
  };

  const getLineErrorClass = (isError: boolean) => {
    return {
      [styles.listItem__error]: isError,
    };
  };

  return (
    <Box paddingLeft="4px">
      <Typography
        className={cn(styles.textLine, getTextErrorClass(minLength))}
        variant="body3"
        color="black"
      >
        Password minimum length - 8 character(s)
      </Typography>
      <ul className={styles.list}>
        <li
          className={cn(styles.listItem, getLineErrorClass(atLeastOneNumber))}
        >
          <Typography
            className={cn(styles.textLine, getTextErrorClass(atLeastOneNumber))}
            variant="body3"
            color="black"
          >
            Contains at least 1 number
          </Typography>
        </li>
        <li
          className={cn(
            styles.listItem,
            getLineErrorClass(atLeastOneSpecialCharacter),
          )}
        >
          <Typography
            className={cn(
              styles.textLine,
              getTextErrorClass(atLeastOneSpecialCharacter),
            )}
            variant="body3"
            color="black"
          >
            Contains at least 1 special character
          </Typography>
        </li>
        <li
          className={cn(
            styles.listItem,
            getLineErrorClass(atLeastOneUppercaseLetter),
          )}
        >
          <Typography
            className={cn(
              styles.textLine,
              getTextErrorClass(atLeastOneUppercaseLetter),
            )}
            variant="body3"
            color="black"
          >
            Contains at least 1 uppercase letter
          </Typography>
        </li>
        <li
          className={cn(
            styles.listItem,
            getLineErrorClass(atLeastOneLowercaseLetter),
          )}
        >
          <Typography
            className={cn(
              styles.textLine,
              getTextErrorClass(atLeastOneLowercaseLetter),
            )}
            variant="body3"
            color="black"
          >
            Contains at least 1 lowercase letter
          </Typography>
        </li>
      </ul>
    </Box>
  );
};
